module.exports = __webpack_public_path__ + "static/media/semiTractorWithTrailer_gray.6eff8c7f.svg";